// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6ad8fe85","107":"669665d1","143":"f81e2136","412":"d98f2dec","495":"ab2658a3","880":"6038c728","883":"10001b79","944":"e6a04d62","955":"e893d1c9"}[chunkId] + ".chunk.js";
};